import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Button,
  Card,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Tabs,
  DialogContent,
  Dialog,
  OutlinedInput,
  InputAdornment,
  TextField,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Avatar,
  Link,
  TablePagination,
  Alert,
  AlertTitle,
  Tooltip,
} from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { Scrollbar } from "../../components/scrollbar";
import { getVotingStatusDisplay } from "../../utils/votingUtils";
import { FileDropzone } from "../../components/file-dropzone";
import {
  getFirestore,
  collection,
  onSnapshot,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";

import XIcon from "@untitled-ui/icons-react/build/esm/X";
import Download01Icon from "@untitled-ui/icons-react/build/esm/Download01";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import Upload01Icon from "@untitled-ui/icons-react/build/esm/Upload01";
import SearchMdIcon from "@untitled-ui/icons-react/build/esm/SearchMd";
import Edit02Icon from "@untitled-ui/icons-react/build/esm/Edit02";
import DeleteIcon from "@untitled-ui/icons-react/build/esm/XSquare";
import { SeverityPill } from "../../components/severity-pill";
import { format, addDays } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

export function Paltas() {
  let navigate = useNavigate();

  const simplesOptions = [
    {
      label: "Todos os tipos",
      value: "todos-tipos",
    },
    {
      label: "Projeto de resolução",
      value: "projetoResolucao",
    },
    {
      label: "Emenda",
      value: "emenda",
    },
    {
      label: "Indicação",
      value: "indicacao",
    },
    {
      label: "Projeto de Decreto Legislativo",
      value: "projetoDecretoLegislativo",
    },
    {
      label: "Projeto de emenda à Lei orgânica",
      value: "projetoEmendaLeiOrganica",
    },
    {
      label: "Projeto de Lei Ordinária",
      value: "projetoLeiOrdinaria",
    },
    {
      label: "Projeto de Lei do Poder Executivo",
      value: "projetoLeiPoderExecutivo",
    },
    {
      label: "Projeto de Lei do Poder Legislativo",
      value: "projetoLeiPoderLegislativo",
    },
    {
      label: "Projeto Substitutivo",
      value: "projetoSubstitutivo",
    },
    {
      label: "Requerimento",
      value: "requerimento",
    },
    {
      label: "Subemenda",
      value: "subemenda",
    },
    {
      label: "Veto",
      value: "veto",
    },
    {
      label: "Pareceres das Comições",
      value: "pareceresComicoes",
    },
    {
      label: "Parecer",
      value: "parecer",
    },
    {
      label: "Mensagem",
      value: "mensagem",
    },
  ];

  const [unidadesGestoras, setUnidadesGestoras] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOnOpen] = useState(false);
  const [idPauta, setIdPauta] = useState("");

  const useSearch = () => {
    const [search, setSearch] = useState({
      filters: {
        query: undefined,
        hasAcceptedMarketing: undefined,
        isProspect: undefined,
        isReturning: undefined,
      },
      page: 0,
      rowsPerPage: 5,
      sortBy: "updatedAt",
      sortDir: "desc",
    });

    return {
      search,
      updateSearch: setSearch,
    };
  };

  const { search, updateSearch } = useSearch();

  //@ts-ignore
  const handlePageChange = useCallback(
    (event: any, page: any) => {
      updateSearch((prevState) => ({
        ...prevState,
        page,
      }));
    },
    [updateSearch]
  );

  //@ts-ignore
  const handleRowsPerPageChange = useCallback(
    (event: any) => {
      updateSearch((prevState) => ({
        ...prevState,
        rowsPerPage: parseInt(event.target.value, 10),
      }));
    },
    [updateSearch]
  );

  useEffect(() => {
    const db = getFirestore();
    const ordersRef = collection(db, "users", "belacruz@eleg", "pautas");
    const unsubscribe = onSnapshot(
      ordersRef,
      (querySnapshot) => {
        const parsedData = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          // Cria um objeto com as propriedades e seus respectivos valores
          const obj = {
            id: doc.id,
            numeroProtocolo: data.numeroProtocolo,
            pautaLegislativa: data.pautaLegislativa,
            votada: data.votada,
            data: data.data,
            opcoesVotacao: data.opcoesVotacao,
            statusAtual: data.statusAtual,
            expressoes: data.expressoes,
            autor: data.autor,
          };
          return obj;
        });

        // Ordenar os dados priorizando não votados e primeiro turno
        parsedData.sort((a, b) => {
          // Função para determinar prioridade
          const getPriority = (item: any) => {
            const statusAtual = item.statusAtual;
            const statusFinalizado =
              statusAtual === "votado" || statusAtual === "finalizada";
            const finalizada = item.votada === true || statusFinalizado;

            // Prioridade 1: Não votado
            if (!finalizada) return 1;

            // Prioridade 2: Primeiro turno (votação de dois turnos)
            if (
              item.opcoesVotacao === "2-turnos" &&
              item.statusAtual === "votacao1turno"
            )
              return 2;

            // Prioridade 3: Segundo turno
            if (
              item.opcoesVotacao === "2-turnos" &&
              item.statusAtual === "votacao2turno"
            )
              return 3;

            // Prioridade 4: Votado/finalizado
            return 4;
          };

          const priorityA = getPriority(a);
          const priorityB = getPriority(b);

          // Se as prioridades são diferentes, ordenar por prioridade
          if (priorityA !== priorityB) {
            return priorityA - priorityB;
          }

          // Se as prioridades são iguais, ordenar por data (mais recente primeiro)
          const dateA = new Date(a.data);
          const dateB = new Date(b.data);
          return dateB.getTime() - dateA.getTime();
        });

        //@ts-ignore
        setUnidadesGestoras(parsedData);
      },
      (error) => {
        console.log("Erro ao recuperar dados da subcoleção:", error);
      }
    );

    return () => unsubscribe();
  }, []);

  const filteredItems = unidadesGestoras.filter((item) => {
    const matchesCategory =
      selectedCategories === "" ||
      selectedCategories === "todos-tipos" ||
      //@ts-ignore
      item.pautaLegislativa === selectedCategories;

    const query = searchQuery.trim().toLowerCase();
    const matchesQuery =
      query === "" ||
      //@ts-ignore
      (item.expressoes || "").replace(/<[^>]*>/g, "").toLowerCase().includes(query) ||
      //@ts-ignore
      (item.numeroProtocolo || "").toLowerCase().includes(query) ||
      //@ts-ignore
      (item.autor || "").toLowerCase().includes(query);

    return matchesCategory && matchesQuery;
  });

  const paginatedData = filteredItems.slice(
    search.page * search.rowsPerPage,
    (search.page + 1) * search.rowsPerPage
  );

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 3.4,
      }}
    >
      <Dialog fullWidth maxWidth="xs" open={open}>
        <DialogContent>
          <Stack
            sx={{
              width: "100%",
            }}
          >
            <Alert severity="warning">
              Não é possível reverter esta ação. Tem certeza?
            </Alert>

            <Stack
              sx={{
                width: "100%",
                alignSelf: "flex-end",
                marginTop: 0,
              }}
              justifyContent="flex-end"
              alignItems="flex-end"
              spacing={2}
              flexDirection="row"
            >
              <Button
                color="error"
                onClick={async () => {
                  const db = getFirestore();
                  //@ts-ignore
                  await deleteDoc(
                    doc(db, "users", "belacruz@eleg", "pautas", `${idPauta}`)
                  );
                  setOnOpen(false);
                }}
              >
                Apagar mesmo assim
              </Button>
              <Button
                color="inherit"
                onClick={() => {
                  setOnOpen(false);
                }}
              >
                Cancelar
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>

      <Container maxWidth="xl">
        <Stack spacing={4} mt={4}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Stack spacing={1}>
              <Typography variant="h4">Pauta legislativas</Typography>
            </Stack>
            <Stack alignItems="center" direction="row" spacing={3}>
              <NavLink to="/pautas/cadastro">
                <Button
                  startIcon={
                    <SvgIcon>
                      <PlusIcon />
                    </SvgIcon>
                  }
                  variant="contained"
                >
                  Adicionar
                </Button>
              </NavLink>
            </Stack>
          </Stack>

          <Card>
            <Stack
              alignItems="center"
              direction="row"
              flexWrap="wrap"
              spacing={3}
              sx={{ p: 3 }}
            >
              <Box component="form" sx={{ flexGrow: 1 }}>
                <OutlinedInput
                  fullWidth
                  placeholder="Adicione uma descrição..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <SvgIcon>
                        <SearchMdIcon />
                      </SvgIcon>
                    </InputAdornment>
                  }
                />
              </Box>
              <TextField
                label="Tipo de Proposições"
                name="sort"
                select
                SelectProps={{ native: true }}
                onChange={(event) => {
                  setSelectedCategories(event.target.value);
                }}
              >
                {simplesOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Stack>

            <Box sx={{ position: "relative" }}>
              <Scrollbar>
                <Table sx={{ minWidth: 800 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox checked={false} />
                      </TableCell>
                      <TableCell>Código</TableCell>
                      <TableCell>Proposições</TableCell>
                      <TableCell>Autor</TableCell>
                      <TableCell>Data</TableCell>
                      <TableCell>Situação</TableCell>
                      <TableCell align="right">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData !== undefined &&
                      paginatedData.map((item) => {
                        //@ts-ignore
                        const labelCorrespondente = simplesOptions.find(
                          //@ts-ignore
                          (opcao) => opcao.value === item.pautaLegislativa
                        );

                        // Usar função utilitária para determinar status e cor
                        const statusInfo = getVotingStatusDisplay(
                          (item as any).votada,
                          (item as any).opcoesVotacao,
                          (item as any).statusAtual
                        );
                        const statusColor = statusInfo.color;
                        const statusVotoPauta = statusInfo.text;

                        //@ts-ignore
                        const dataPauta = format(
                          //@ts-ignore
                          addDays(new Date(item.data), 1),
                          "dd 'de' MMM",
                          { locale: ptBR }
                        );

                        return (
                          <TableRow
                            hover
                            //@ts-ignore
                            key={item.id}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox checked={false} />
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {item.numeroProtocolo}
                            </TableCell>
                            <TableCell>
                              <div>
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    marginBottom: "4px",
                                  }}
                                >
                                  {/*@ts-ignore*/}
                                  {labelCorrespondente.label}
                                </div>
                                <div
                                  style={{
                                    fontSize: "0.875rem",
                                    color: "#666",
                                  }}
                                >
                                  {/*@ts-ignore*/}
                                  <Tooltip
                                    title={(() => {
                                      const expressoes =
                                        (item as any).expressoes ||
                                        "Sem expressões";
                                      return expressoes.replace(/<[^>]*>/g, "");
                                    })()}
                                    arrow
                                  >
                                    <span>
                                      {(() => {
                                        const expressoes =
                                          (item as any).expressoes ||
                                          "Sem expressões";
                                        // Remover tags HTML
                                        const textoLimpo = expressoes.replace(
                                          /<[^>]*>/g,
                                          ""
                                        );
                                        return textoLimpo.length > 60
                                          ? `${textoLimpo.substring(0, 60)}...`
                                          : textoLimpo;
                                      })()}
                                    </span>
                                  </Tooltip>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {(item as any).autor || "Não informado"}
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {dataPauta}
                            </TableCell>
                            <TableCell>
                              <SeverityPill color={statusColor}>
                                {statusVotoPauta}
                              </SeverityPill>
                            </TableCell>
                            <TableCell align="right">
                              <IconButton
                                onClick={() => {
                                  setOnOpen(true);
                                  //@ts-ignore
                                  setIdPauta(`${item.id}`);
                                }}
                              >
                                <SvgIcon>
                                  <DeleteIcon />
                                </SvgIcon>
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  //@ts-ignore
                                  navigate(`/pauta/${item.id}/edit`);
                                }}
                              >
                                <SvgIcon>
                                  <Edit02Icon />
                                </SvgIcon>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Scrollbar>

              <TablePagination
                component="div"
                count={unidadesGestoras.length}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                page={search.page}
                rowsPerPage={search.rowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Linhas por página"
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}-${to} de ${count}`
                }
              />
            </Box>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
}
